const WORDS = [
  "Kitchen Ateliers",
  "Spa Bathrooms",
  "Outdoor Decks",
  "Artisan Painting",
  "Structural Craft",
  "White-Glove Handover",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-line bg-surface py-6"
    >
      <div className="animate-marquee-slow flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((w, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display text-2xl font-medium tracking-tight text-cream/70 sm:text-3xl"
              >
                <span className="px-6">{w}</span>
                <span className="h-2 w-2 rotate-45 bg-copper" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
